import React, { useEffect, useState } from "react";
import HowWeCanHelp from "../common/HowWeCanHelp";
import { useParams } from "react-router-dom";
import HTMLReactParser from "html-react-parser";
import { getSingleTender } from "../../services/TenderServices";
export const TenderDetails = () => {
  //   const { blogDetails } = useSelector((state) => state.blog);
  const [tenderDetails, setTenderDetails] = useState({});
  const { id } = useParams();
  useEffect(() => {
    if (id) {
      getSingleTender(id).then((res) => {
        if (res.status == "success") {
          setTenderDetails(res?.data);
        }
      });
    }
  }, [id]);
  return (
    <div className="background_light">
      <div className="container">
        <div className="row py-5 justify-content-between">
          <div className="col-md-7">
            <h1 className="fw-bold ff_inter fs_37 color_darkgray">
              {tenderDetails.title}
            </h1>
            <p className="fw-bold color_light_blue ff_inter mt-3">
              {tenderDetails?.openingDate}
            </p>
            <div className="blogDetailsWrapper ff_inter mt-2">
              {HTMLReactParser(tenderDetails?.description || "")}
            </div>
            <p className="mt-4 ff_inter">
              <strong className="fs-5"> Scope of Work:</strong>{" "}
              {HTMLReactParser(tenderDetails?.scopeOfWork || "")}
            </p>
            <p className="fw-bold ff_inter text-black mt-3">
              Last date for submission: {tenderDetails?.lastDate}
            </p>
            <a
              href={tenderDetails?.document}
              download
              className="btn text-white tab_btn ff_inter fw-semibold mt-3 px-5 py-2"
            >
              Click here for complete Tender Details and Documents
            </a>
          </div>
          <HowWeCanHelp />
        </div>
      </div>
    </div>
  );
};
